import { render, staticRenderFns } from "./menu-item-worker.vue?vue&type=template&id=133c0f78&scoped=true&"
import script from "./menu-item-worker.vue?vue&type=script&lang=js&"
export * from "./menu-item-worker.vue?vue&type=script&lang=js&"
import style0 from "./menu-item-worker.vue?vue&type=style&index=0&id=133c0f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c0f78",
  null
  
)

export default component.exports